<template>
  <div :class="[classes(n('--content')), classes(n(`--content--default`))]">
    <div
      v-for="(keysSetting, i) in chunkedSetting"
      :key="`keyboard-column-${i}`"
      :class="[classes(n(`--content--default--item`))]"
    >
      <div
        v-for="item in keysSetting"
        :key="item.key"
        :class="[n(`--content--default--item--split`)]"
      >
        <KeyboardItem
          :class="[n(`--content--default--item--key`), item.className ? n(`--content--item--${item.className}`) : '']"
          :value="item.key"
          :safe-mode="safeMode"
          :confirm-btn-text="confirmBtnText"
          @click="handleClick"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'virtual-vue';
import { createNamespace } from '../../utils/components';
import { getDefaultKeyboardSetting, splitKeyboardKeys } from '../business';
import KeyboardItem from './keyboard-item.vue';
import { props } from '../props';
import { KeyboardEmitsEvent } from '../emits';


const { name, n, classes } = createNamespace('keyboard');

/**
 * 普通键盘布局展示
 * @description 默认普通键盘.
 */
export default defineComponent({
  name: `${name}-default`,
  components: { KeyboardItem },
  props,
  emits: ['click'],
  setup(props, { emit }) {
    const setting = getDefaultKeyboardSetting(props.decimal);
    const chunkedSetting = reactive(splitKeyboardKeys(setting));

    /**
     * 点击键盘触发事件
     * @param options 参数
     */
    function handleClick(options: { type: KeyboardEmitsEvent, value?: string }) {
      emit('click', options);
    }

    return {
      n,
      classes,
      chunkedSetting,
      handleClick,
    };
  },
});
</script>
